import React, { useState, lazy, Suspense, memo, useContext } from 'react';
import { SttTabs, SttTranslateHook } from '@stt-componentes/core-v2';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    wrapper: {
        padding: theme.spacing(1)
    }
}));

const Fila = lazy(() => import('./fila/Fila'));

const FilaSuspense = memo((props) => {
    return (
        <Suspense>
            <Fila {...props} />
        </Suspense>
    );
});

const Automacao = ({ props }) => {
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const classes = useStyles();

    const abas = [
        {
            titulo: strings.recuparacaoExames,
            conteudo: FilaSuspense,
            key: 'FilaSuspense',
            permanente: true,
        },
    ];

    const [abaAtiva, setAbaAtiva] = useState('0');

    return <SttTabs abas={abas} className={classes.wrapper} handleChangeAbaAtiva={setAbaAtiva} abaAtiva={abaAtiva} permanente={true} preload={false} />;
};

export default Automacao;
